import React from 'react';
import { Form } from 'react-bootstrap';
import { FilterFieldType } from './CustomFilter';

interface BooleanOptionProps {
	field: FilterFieldType;
	activeFilters: { [key: string]: string[] };
	setActiveFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}

const BooleanOption: React.FC<BooleanOptionProps> = ({ field, activeFilters, setActiveFilters }) => {
	return (
		<div
			style={{
				width: '100%',
				display: 'grid',
				gap: '1rem',
			}}
		>
			{field.options.map((option) => {
				const isChecked = activeFilters[field.name]?.[0] === option.value;
				if (option.value === 'none') return null;
				return (
					<div
						key={option.label}
						style={{
							borderRadius: '8px',
							padding: '1rem',
							border: '1px solid #C7CFD7',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						{option.label}

						<Form.Check
							type="switch"
							className="custom-switch custom-switch-primary"
							id={`custom-switch-${field.name}`}
							checked={isChecked}
							onChange={() => {
								if (!isChecked) {
									setActiveFilters((prevActiveFilters) => ({
										...prevActiveFilters,
										[field.name]: [option.value],
									}));
								} else {
									const { [field.name]: _, ...rest } = activeFilters;
									setActiveFilters(rest);
								}
							}}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default BooleanOption;
